import { render, staticRenderFns } from "./package_price.vue?vue&type=template&id=57a52d36"
import script from "./package_price.vue?vue&type=script&lang=js"
export * from "./package_price.vue?vue&type=script&lang=js"
import style0 from "./package_price.vue?vue&type=style&index=0&id=57a52d36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports